export enum PropertiesEnum {
	description = 'description',
	technicalDescription = 'technicalDescription',
	calculationDescription = 'calculationDescription',
	originDescription = 'originDescription',
	originCalculation = 'originCalculation',
	sourceSystem = 'sourceSystem',
	dataType = 'dataType',
}
